import { FC, JSX } from 'react'
import { VenueAddress, VenueAddressType } from './Address'
import { VenueAvatar, VenueAvatarType } from './Avatar'
import { VenueAvatarGroup, VenueAvatarGroupType } from './AvatarGroup'
import { VenueAvatarModal, VenueAvatarModalType } from './AvatarModal'
import { BookingOverview, BookingOverviewType } from './BookingOverview'
import { VenueDominoConfig, VenueDominoConfigType } from './DominoConfig'
import { VenueMap, VenueMapType } from './Map'
import { VenueMenu, VenueMenuType } from './Menu'
import { VenueOption, VenueOptionType } from './Option'
import {
  SettingWhatsAppVenue,
  SettingWhatsAppVenueType,
} from './SettingWhatsAppVenue'
import { VenueTypeTag, VenueTypeTagType } from './TypeTag'
import {
  VisibilityOverview,
  VisibilityOverviewType,
} from './VisibilityOverview'
import {
  WhatsappEmbeddedSignup,
  WhatsappEmbeddedSignupType,
} from './WhatsappEmbeddedSignup'

export const Venue: FC &
  VenueAvatarType &
  VenueAvatarGroupType &
  VenueAvatarModalType &
  VenueAddressType &
  VenueTypeTagType &
  VenueMenuType &
  VisibilityOverviewType &
  SettingWhatsAppVenueType &
  BookingOverviewType &
  VenueMapType &
  WhatsappEmbeddedSignupType &
  VenueOptionType &
  VenueDominoConfigType = (): JSX.Element => <></>

Venue.Avatar = VenueAvatar
Venue.AvatarGroup = VenueAvatarGroup
Venue.AvatarModal = VenueAvatarModal
Venue.Address = VenueAddress
Venue.TypeTag = VenueTypeTag
Venue.Menu = VenueMenu
Venue.VisibilityOverview = VisibilityOverview
Venue.BookingOverview = BookingOverview
Venue.SettingWhatsAppVenue = SettingWhatsAppVenue
Venue.WhatsappEmbeddedSignup = WhatsappEmbeddedSignup
Venue.Map = VenueMap
Venue.Option = VenueOption
Venue.DominoConfig = VenueDominoConfig
